'use client';

import {
  getCategorias,
  // getDestaques,
  listarCombos,
  listarProdutos,
} from '@/services/marketplaceService';
import { Categoria } from '@/types/categoria';
import { Combo } from '@/types/combo';
// import { Destaque } from '@/types/destaque';
import { Produto } from '@/types/produto';
import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

import { StaticImageData } from 'next/image';
import banner_imovision from '@/assets/banner_imovision.png';
import banner_gift_card_mobile from '@/assets/banner_gift_card_mobile.png';
import { MotivoDenunciaResenha } from '@/types/resenha';
import { listarTiposDenunciaResenha } from '@/services/resenhaService';
import { listarPlaylistsUsuario } from '@/services/playlistsService';
import { ArgumentosListarPlaylistsUsuario } from '@/services/types/playlists';
import { Favoritos, Playlist, VerDepois } from '@/types/playlists';
import { GaleriaImagem } from '@/components/molecules/Galeria';
import {
  listarConteudosEmAltaStreaming,
  listarFilmesEmCartaz,
} from '@/services/conteudoService';
import { ConteudoRecomendacao } from '@/services/types/recomendacao';

interface HomePageDataType {
  categorias: Array<Categoria> | null;
  // destaquesMobile: Array<Destaque> | null;
  destaquesMobile: Array<StaticImageData>;
  destaquesDesktop: Array<GaleriaImagem>;
  produtos: Array<Produto> | null;
  combos: Array<Combo> | null;
  assinaturas: Array<Produto> | null;
  carregandoAssinaturas: boolean;
  tiposDenunciaResenha: MotivoDenunciaResenha[] | null;
  setCategorias: Dispatch<SetStateAction<Categoria[] | null>>;
  // setDestaques: Dispatch<SetStateAction<Destaque[] | null>>;
  setProdutos: Dispatch<SetStateAction<Produto[] | null>>;
  setCombos: Dispatch<SetStateAction<Combo[] | null>>;
  recuperarCategorias: () => void;
  setAssinaturas: Dispatch<SetStateAction<Produto[] | null>>;
  recuperarProdutos: () => void;
  recuperarCombos: () => void;
  recuperarAssinaturas: () => void;
  recuperarTiposDenunciaResenha: () => void;
  recuperarListasUsuario: (
    props: ArgumentosListarPlaylistsUsuario,
  ) => Promise<void>;
  categoriaTodos: Categoria;
  playlistsUsuario: Playlist[] | null;
  favoritos: Favoritos[] | null;
  verDepois: VerDepois[] | null;
  loadingListasUsuario: boolean;
  recuperarEmAltaStreaming: () => void;
  emAltaStreaming: Array<ConteudoRecomendacao> | null;
  carregandoEmAltaStreaming: boolean;
  recuperarFilmesEmCartaz: () => void;
  filmesEmCartaz: Array<ConteudoRecomendacao> | null;
  carregandoFilmesEmCartaz: boolean;
}

export const HomePageDataContext = createContext<HomePageDataType | undefined>(
  undefined,
);

export const HomePageDataProvider = ({ children }: { children: ReactNode }) => {
  const [categorias, setCategorias] = useState<Array<Categoria> | null>(null);
  const [destaquesMobile] = useState<StaticImageData[]>([
    banner_gift_card_mobile,
    //   const [destaques] = useState<Array<Destaque> | null>([
    // {
    //   nome: 'Destaque Chippu Place',
    //   imagem:
    //     'https://chippu2-bucket.s3.us-east-1.amazonaws.com/MarketplaceDestaque/DESKTOP_CHIPPU_PLACE.png',
    //   imagemMobile:
    //     'https://chippu2-bucket.s3.us-east-1.amazonaws.com/MarketplaceDestaque/MOBILE_CHIPPU_PLACE.png',
    //   id: 1,
    //   linkExterno: 'https://chippu.com.br',
    //   produtoID: null,
    // },
    // {
    //   nome: 'Destaque Giftcards Gamescom',
    //   imagem:
    //     'https://d2d7ho1ae66ldi.cloudfront.net/ArquivoCombos/b40e1610-2600-11f0-aa7d-b1a1e9a25cc3/PLACE_GAMES_DESKTOP_2.png',
    //   imagemMobile:
    //     'https://d2d7ho1ae66ldi.cloudfront.net/ArquivoCombos/4911b6ac-2602-11f0-aa7d-b1a1e9a25cc3/gamescom+banner+place+teste.png',
    //   id: 2,
    //   linkExterno: 'https://chippu.com.br',
    //   produtoID: null,
    // },
  ]);
  const [destaquesDesktop] = useState<GaleriaImagem[]>([
    {
      imagem: banner_imovision,
      abrirExterno: true,
      link: 'https://www.chippu.com.br/assinatura/imovision-1',
    },
  ]);
  const [produtos, setProdutos] = useState<Array<Produto> | null>(null);
  const [combos, setCombos] = useState<Array<Combo> | null>(null);
  const [assinaturas, setAssinaturas] = useState<Array<Produto> | null>(null);
  const [tiposDenunciaResenha, setTiposDenunciaResenha] = useState<
    MotivoDenunciaResenha[] | null
  >(null);
  const [playlistsUsuario, setPlaylistsUsuario] = useState<Playlist[] | null>(
    null,
  );
  const [favoritos, setFavoritos] = useState<Favoritos[] | null>(null);
  const [verDepois, setVerDepois] = useState<VerDepois[] | null>(null);
  const [emAltaStreaming, setEmAltaStreaming] =
    useState<Array<ConteudoRecomendacao> | null>(null);

  const [filmesEmCartaz, setFilmesEmCartaz] =
    useState<Array<ConteudoRecomendacao> | null>(null);

  const [carregandoCategorias, setCarregandoCategorias] = useState(false);
  const [carregandoProdutos, setCarregandoProdutos] = useState(false);
  const [carregandoCombos, setCarregandoCombos] = useState(false);
  const [carregandoAssinaturas, setCarregandoAssinaturas] =
    useState<boolean>(false);
  const [loadingTipoDenuncia, setLoadingTipoDenuncia] = useState(false);
  const [loadingListasUsuario, setLoadingListasUsuario] = useState(false);
  const [carregandoEmAltaStreaming, setCarregandoEmAltaStreaming] =
    useState(false);
  const [carregandoFilmesEmCartaz, setCarregandoFilmesEmCartaz] =
    useState(false);

  const categoriaTodos: Categoria = {
    cor: '',
    icone: '',
    id: '',
    nome: 'Todos',
    marketPlaceCategoriaID: '',
  };

  async function recuperarCategorias() {
    if (categorias?.length || carregandoCategorias) return;
    setCarregandoCategorias(true);
    try {
      const categoriasFromServer = await getCategorias();
      setCategorias([categoriaTodos, ...(categoriasFromServer ?? [])]);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoCategorias(false);
    }
  }

  // async function recuperarDestaques() {
  //   if (destaques?.length) return;
  //   const destaquesFromServer = await getDestaques();
  //   setDestaques(destaquesFromServer);
  // }

  async function recuperarProdutos() {
    if (produtos?.length || carregandoProdutos) return;
    try {
      setCarregandoProdutos(true);
      const produtosFromServer = await listarProdutos({
        filtros: 'somenteBeneficio == false && assinatura == false',
      });
      setProdutos(produtosFromServer);

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoProdutos(false);
    }
  }

  async function recuperarAssinaturas() {
    if (assinaturas?.length || carregandoAssinaturas) return;
    setCarregandoAssinaturas(true);
    try {
      const assinaturasFromServer = await listarProdutos({
        filtros: 'assinatura == true',
      });
      setAssinaturas(assinaturasFromServer);

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoAssinaturas(false);
    }
  }

  async function recuperarTiposDenunciaResenha() {
    if (tiposDenunciaResenha?.length || loadingTipoDenuncia) return;
    setLoadingTipoDenuncia(true);
    try {
      const tiposDenunciaFromServer = await listarTiposDenunciaResenha();
      setTiposDenunciaResenha(tiposDenunciaFromServer.dados.lista);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setLoadingTipoDenuncia(false);
    }
  }

  async function recuperarListasUsuario(
    props: ArgumentosListarPlaylistsUsuario,
  ) {
    if (loadingListasUsuario) return;
    setLoadingListasUsuario(true);
    try {
      const playlistsUsuarioFromServer = await listarPlaylistsUsuario(props);
      setPlaylistsUsuario(playlistsUsuarioFromServer.dados.lista);
      setFavoritos(playlistsUsuarioFromServer.dados.favoritos);
      setVerDepois(playlistsUsuarioFromServer.dados.verDepois);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setLoadingListasUsuario(false);
    }
  }

  async function recuperarCombos(filtros?: string) {
    if (combos?.length || carregandoCombos) return;
    setCarregandoCombos(true);
    try {
      const combosFromServer = await listarCombos(filtros ? { filtros } : {});
      setCombos(combosFromServer);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoCombos(false);
    }
  }

  async function recuperarEmAltaStreaming() {
    try {
      if (emAltaStreaming?.length || carregandoEmAltaStreaming) return;
      setCarregandoEmAltaStreaming(true);
      const conteudosEmAltaStreaming = await listarConteudosEmAltaStreaming();
      setEmAltaStreaming(conteudosEmAltaStreaming);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoEmAltaStreaming(false);
    }
  }

  async function recuperarFilmesEmCartaz() {
    try {
      if (filmesEmCartaz?.length || carregandoFilmesEmCartaz) return;
      setCarregandoFilmesEmCartaz(true);
      const conteudosFilmesEmCartaz = await listarFilmesEmCartaz();
      setFilmesEmCartaz(conteudosFilmesEmCartaz);

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoFilmesEmCartaz(false);
    }
  }

  return (
    <HomePageDataContext.Provider
      value={{
        categorias,
        setCategorias,
        destaquesMobile,
        destaquesDesktop,
        // setDestaques,
        produtos,
        setProdutos,
        combos,
        setCombos,
        assinaturas,
        carregandoAssinaturas,
        setAssinaturas,
        recuperarCategorias,
        // recuperarDestaques,
        recuperarProdutos,
        recuperarCombos,
        recuperarAssinaturas,
        categoriaTodos,
        recuperarTiposDenunciaResenha,
        recuperarListasUsuario,
        tiposDenunciaResenha,
        playlistsUsuario,
        favoritos,
        verDepois,
        loadingListasUsuario,
        recuperarEmAltaStreaming,
        emAltaStreaming,
        carregandoEmAltaStreaming,
        recuperarFilmesEmCartaz,
        filmesEmCartaz,
        carregandoFilmesEmCartaz,
      }}
    >
      {children}
    </HomePageDataContext.Provider>
  );
};
